import { useContext } from "react";
import { CredentialContext } from "./CredentialContext";

export const useCredentials = () => {
  return useContext(CredentialContext);
};
